import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { SpecificDestination as SpecificDestinationModel } from 'models/specificDestination';
import { getFormattedPrice } from 'utils/currency';

import { PreviewContainer, Item, ValuesContainer, Point } from '../styles';

interface Props {
  values: SpecificDestinationModel[];
  countryCurrency: string;
}

const PreviewItemsDestination = ({ values, countryCurrency }: Props) => {
  const { t } = useStoreTranslation();
  const formattedPrice = (value: number | undefined) => {
    const { formatted } = getFormattedPrice({ value, currency: countryCurrency, t });
    return formatted;
  };

  return (
    <PreviewContainer>
      {values.slice(0, 3).map((value) => (
        <Item key={`${value.destinationPoint?.code}`}>
          <Item.Title>{value.destinationPoint?.name}</Item.Title>
          <ValuesContainer>
            <Item.Value>
              {value.dateHotel && value.dateHotel > 0
                ? `${value.dateHotel}
                  ${t('rule.restriction.anticipationSuffix')}`
                : t('rule.restriction.withoutRestriction')}
            </Item.Value>
            <Point> • </Point>
            <Item.Value>
              {value.maxPrice ? formattedPrice(value.maxPrice) : t('rule.restriction.withoutRestriction')}
            </Item.Value>
          </ValuesContainer>
        </Item>
      ))}
    </PreviewContainer>
  );
};

export default PreviewItemsDestination;
